module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class=\'note\'>'+
((__t=(message))==null?'':__t)+
'</div>\n';
}
return __p;
};
